import { useBackHandler } from '@/back';
import { BACKLINK } from '@/components/layout';
import { useCovered, useInSheet } from '@/covered';

export function BackLink({ label, onClick }: { label: string; onClick: () => void }) {
  const covered = useCovered();
  const inSheet = useInSheet();
  useBackHandler(!covered && !inSheet, onClick);
  return (
    <button type="button" className={BACKLINK} onClick={onClick}>
      <span className="text-t14" aria-hidden>
        ←
      </span>
      <span>{label}</span>
    </button>
  );
}
